import { motion, useMotionValue, useSpring } from "framer-motion";
import { useEffect, useRef } from "react";
import networks from "../assets/networks.png";

export default function FounderMessage() {

  /* ---------------- MOUSE MOTION ---------------- */
  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);

  // Smooth cinematic movement
  const mouseX = useSpring(rawX, { stiffness: 40, damping: 20 });
  const mouseY = useSpring(rawY, { stiffness: 40, damping: 20 });

  /* ---------------- ROTATION ---------------- */
  const rotate = useMotionValue(0);
  const angleRef = useRef(0);

  /* ---------------- MOUSE FOLLOW ---------------- */
  useEffect(() => {
    const move = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 60;
      const y = (e.clientY / window.innerHeight - 0.5) * 60;
      rawX.set(x);
      rawY.set(y);
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [rawX, rawY]);

  /* ---------------- CINEMATIC ROTATION LOOP ---------------- */
  useEffect(() => {
    let frame;
    const ROTATE_SPEED = 0.05;   // 🔥 change speed here

    const loop = () => {
      angleRef.current += ROTATE_SPEED;
      if (angleRef.current >= 360) angleRef.current = 0;
      rotate.set(angleRef.current);
      frame = requestAnimationFrame(loop);
    };

    frame = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(frame);
  }, [rotate]);

  /* ---------------- UI ---------------- */
  return (
    <section className="bg-white py-28 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6">

        {/* Heading */}
        <h2 className="text-center text-3xl md:text-4xl font-bold mb-16">
          Founder’s <span className="text-primary">Message</span>
        </h2>

        {/* MESSAGE CONTENT — FULL WIDTH */} <div className="text-gray-600 leading-relaxed text-sm md:text-base text-justify"> <p>To Our Investors and Partners,</p> <p className="mt-4">Welcome to Yield Ventures.</p> <p className="mt-4"> We stand at the precipice of a global economic realignment. India is not merely growing; it is evolving into the world’s primary engine of value creation. </p> <p className="mt-4">​As we accelerate toward Viksit Bharat 2047—the centenary of our independence—we are participating in what global analysts project will be the rise of a $30 trillion economy¹. The data is unequivocal: India is on track to become the world’s third-largest economy by 2027², driven by a unique convergence of demographics, digitization, and domestic consumption. This is not just a market cycle; it is a structural "Great Reset." </p> <p className="mt-4">​At Yield Ventures, we view this national trajectory as a personal responsibility. We are building an institution engineered for this era of maturity—a shift from the volatility of speculation to the certainty of sustainable wealth creation. </p> <p className="mt-4"> <strong>The "Phygital" Gap:</strong>Trust in a Digital Age <br/>With over 14 years of experience across the capital markets ecosystem, I have learned a fundamental truth: Technology can process a transaction, but only humans can build trust. </p> <p className="mt-4">​While the fintech revolution has successfully democratized access to markets, it has often created a vacuum of guidance. We are bridging this gap with our unique "Phygital" approach. We combine a frictionless, future-ready digital platform with the tangible reliability of human expertise. We do not seek to replace the relationship with an algorithm; we use technology to empower the relationship. </p> <p className="mt-4"> <strong>Compliance is Our Currency</strong> <br/>In a rapidly maturing regulatory landscape, our operating philosophy is absolute: Compliance with Conscience. </p> <p className="mt-4">​We view risk management not as a regulatory hurdle, but as the bedrock of longevity. By adhering to the spirit—not just the letter—of the law, we protect our stakeholders from the systemic shocks that remove weaker players from the board. In the financial world, stability is the ultimate alpha. </p> <p className="mt-4"> <strong>Serving the Underserved Center</strong> <br/>The "underserved center" of our economy—the ambitious middle class and the rising affluent—deserves institutional-grade opportunities. Whether through democratizing access to Alternative Investment Funds (AIFs) or providing structured Margin Trading Facilities, we are bringing the instruments of the elite to the engine of India’s growth. </p> <p className="mt-4">​We are not just brokers; we are custodians of your financial future. Our mission is to deploy capital prudently, manage risk proactively, and ensure that every action we take yields trust, yields stability, and yields sustainable growth. </p> <p className="mt-4">​India’s growth story is being written now. Let us partner in the wealth creation journey. </p> <p className="mt-6 font-medium text-gray-800"> Sincerely,<br /> Gaurav Jayaswal<br /> Founder, Yield Ventures </p> </div> </div>
      {/* ---------- CINEMATIC NETWORK ---------- */}
      <motion.img
        src={networks}
        alt="network"
        className="absolute bottom-0 left-[-130px] w-[520px] opacity-90 pointer-events-none"
        style={{
          x: mouseX,
          y: mouseY,
          rotateZ: rotate,
          rotateX: -8,
          rotateY: 8,
        }}
      />
    </section>
  );
}
